export const CHAT_TABLE_ROW_ACTIONS_CONFIG = {
  itemIdKey: 'uuid',
}
